<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="slot1">
      <input type="checkbox" class="custom-control-input mgntp10" id="slot1" value="8am - 11am" name="contact_time"
        [(ngModel)]="hgTimeSlots.slot1" (click)="getTimetoContact($event)" />
      <label class="custom-control-label font20" for="slot1">8am - 11am</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="slot2">
      <input type="checkbox" class="custom-control-input mgntp10" id="slot2" value="11am - 2pm"
        name="contact_time" [(ngModel)]="hgTimeSlots.slot2" (click)="getTimetoContact($event)" />
      <label class="custom-control-label font20" for="slot2">11am - 2pm</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="slot3">
      <input type="checkbox" class="custom-control-input mgntp10" id="slot3" value="2pm - 6pm" name="contact_time"
        [(ngModel)]="hgTimeSlots.slot3" (click)="getTimetoContact($event)" />
      <label class="custom-control-label font20" for="slot3">2pm - 6pm</label>
    </label>
  </div>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
    (click)="next();">Next</button>
</div>
<div class="container mobileview mt-4 mb-4 px-0" [attr.id]="questionObj._id" style="float:left !important">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label class="custom-control custom-checkbox chkbox mb-2" for="slot1_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="slot1_mob" value="8am - 11am"
          name="contact_time" [(ngModel)]="hgTimeSlots.slot1" (click)="getTimetoContact($event)" />
        <label class="custom-control-label font20" for="slot1_mob">8am - 11am</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="slot2_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="slot2_mob" value="11am - 2pm"
          name="contact_time" [(ngModel)]="hgTimeSlots.slot2" (click)="getTimetoContact($event)" />
        <label class="custom-control-label font20" for="slot2_mob">11am - 2pm</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="slot3_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="slot3_mob" value="2pm - 6pm" name="contact_time"
          [(ngModel)]="hgTimeSlots.slot3" (click)="getTimetoContact($event)" />
        <label class="custom-control-label font20" for="slot3_mob">2pm - 6pm</label>
      </label>
    </div>
    <div style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right">
        <h1 class="ansMob text-right">Best time to call me is
          from {{contact_time}}</h1>
      </div>
    </div>
  </div>
</div>